import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { Provider } from "@redotech/redo-order-common/provider";
import { CompensationMethod } from "@redotech/redo-return-core-common/compensation-method";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import {
  compensationMethodFields,
  customerRequestTypeFields,
  returnIdFields,
  returnProviderFields,
  returnReasonsFields,
  returnTagsFields,
  returnTotalValueFields,
} from "../common-fields";

export const returnProcessingSchema = defineSchema({
  fields: {
    ...returnIdFields,
    ...compensationMethodFields,
    ...customerRequestTypeFields,
    ...returnTagsFields,
    ...returnTotalValueFields,
    ...returnProviderFields,
    skus: {
      dataType: "Multiple Text",
      documentation: "The SKUs of the products being returned.",
    },
    productTags: {
      dataType: "Multiple Text",
      documentation: "The tags of all the products in the return.",
    },
    ...returnReasonsFields,
    merchantCreated: {
      dataType: "Boolean",
      hideFromInsertionModal: true,
      documentation: "Whether the return was created by the merchant.",
    },
    greenReturn: {
      dataType: "Boolean",
      hideFromInsertionModal: true,
      documentation:
        "Whether the return is a green return (customer keeps all items).",
    },
    isFlagged: {
      dataType: "Boolean",
      label: "Flagged",
      hideFromInsertionModal: true,
      documentation: "Whether the return is flagged.",
    },
  },
});

export const exampleReturnProcessingSchemaInstance: SchemaInstance<
  typeof returnProcessingSchema
> = {
  returnId: "65b81f41da22f4000718b34e",
  compensationMethod: [CompensationMethod.REFUND],
  customerRequestType: ReturnTypeEnum.RETURN,
  returnTags: ["high-value"],
  returnTotalValue: "$100.00",
  provider: Provider.SHOPIFY,
  skus: ["SKU-1"],
  productTags: ["tag1"],
  returnReasons: ["Does not fit"],
  merchantCreated: false,
  greenReturn: false,
  isFlagged: false,
};
